import { Award, Users } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PROFILE_IMAGE =
  "https://images.unsplash.com/photo-1782398138808-694776d26c4c?crop=entropy&cs=srgb&fm=jpg&q=85";

export const CompanyProfile = () => (
  <section id="about" className="py-20 lg:py-28 bg-cream" data-testid="company-profile-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal>
        <div className="relative rounded-2xl overflow-hidden border border-ink/10 aspect-[4/3] shadow-sm">
          <img
            src={PROFILE_IMAGE}
            alt="Container terminal operations"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A140F]/50 via-transparent to-transparent" />
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <p className="label-eyebrow text-gold-muted mb-3">Who We Are</p>
        <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-ink">
          Three Decades of Clearing Cargo, Built on One License.
        </h2>
        <p className="mt-5 text-base text-ink-soft leading-relaxed">
          Ferguson's Customs Broker &amp; Freight Forwarders Ltd has operated since 1996, led by
          Managing Director Marcia A. Bent — a licensed Customs Broker since February 1993 and one
          of the first Diploma graduates in Customs Brokerage from the University of Technology,
          Jamaica. She is an accredited ASYCUDA trainer and a former President of the Customs
          Brokers &amp; Freight Forwarders Association of Jamaica (CBFFAJ), the region's most
          influential professional body of its kind since 1965.
        </p>
        <p className="mt-4 text-base text-ink-soft leading-relaxed">
          She has advised clients ranging from the United States Embassy and the Trinidad and
          Tobago High Commission to Jamaica's Ministry of Agriculture &amp; Fisheries and Ministry
          of Health — and today works alongside her son, Pete Ferguson, Director and Company
          Secretary, to extend that same standard of service to businesses and individuals alike.
        </p>

        <div className="mt-8 grid sm:grid-cols-2 gap-5">
          <div className="flex items-start gap-3" data-testid="profile-stat-licensed">
            <Award size={20} className="text-gold-muted shrink-0 mt-0.5" />
            <div>
              <div className="font-display font-semibold text-ink">Licensed Since 1993</div>
              <div className="text-sm text-ink-soft">Jamaica Customs Agency bonded broker</div>
            </div>
          </div>
          <div className="flex items-start gap-3" data-testid="profile-stat-leadership">
            <Users size={20} className="text-gold-muted shrink-0 mt-0.5" />
            <div>
              <div className="font-display font-semibold text-ink">Former CBFFAJ President</div>
              <div className="text-sm text-ink-soft">2014 – 2017, Jamaica's leading brokers' association</div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
